export default __webpack_public_path__ + "static/spotlight-on-fostering-creativity-016c714140c1eaa4f78462f00dcbf491.png";